import React, { useState } from 'react';
import { db } from '../../firebase/config';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../contexts/ToastContext';

const NotificationModal = ({ isOpen, onClose }) => {
    const { currentUser, userData, isAdmin } = useAuth();
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        title: '',
        message: '',
        type: 'announcement'
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!isAdmin) {
            showToast('Admin privileges required', 'error');
            return;
        }

        setLoading(true);

        try {
            await addDoc(collection(db, 'notifications'), {
                title: formData.title,
                message: formData.message,
                type: formData.type,
                sentBy: currentUser.uid,
                sentByName: userData?.firstName + ' ' + userData?.lastName,
                sentAt: serverTimestamp(),
                readBy: []
            });

            showToast('Notification sent successfully!', 'success');
            onClose();
            setFormData({
                title: '',
                message: '',
                type: 'announcement'
            });
        } catch (error) {
            console.error('Error sending notification:', error);
            showToast('Error sending notification', 'error');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3 className="modal-title">
                        <i className="fas fa-bell"></i> Send Notification
                    </h3>
                    <button className="close-modal" onClick={onClose}>&times;</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="title">Title *</label>
                        <input
                            type="text"
                            id="title"
                            className="form-control"
                            placeholder="Notification title"
                            value={formData.title}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="message">Message *</label>
                        <textarea
                            id="message"
                            className="form-control"
                            rows="4"
                            placeholder="Enter your message here..."
                            value={formData.message}
                            onChange={handleChange}
                            required
                        ></textarea>
                    </div>
                    <div className="form-group">
                        <label htmlFor="type">Notification Type</label>
                        <select
                            id="type"
                            className="form-control"
                            value={formData.type}
                            onChange={handleChange}
                        >
                            <option value="announcement">General Announcement</option>
                            <option value="event">Event Reminder</option>
                            <option value="urgent">Urgent Notice</option>
                            <option value="prayer">Prayer Request</option>
                        </select>
                    </div>
                    <button 
                        type="submit" 
                        className="btn btn-admin" 
                        style={{ width: '100%' }}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <i className="fas fa-spinner fa-spin"></i> Sending...
                            </>
                        ) : (
                            <>
                                <i className="fas fa-paper-plane"></i> Send Notification
                            </>
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default NotificationModal;
